(function($) {


  function mobileNav() {
    var hamburgerBtn = $('header .mobile-button');
    var navPanel = $('header nav');
    var bars = $('header .mobile-button .bar');
    var active = 'is-active';
    var froze = 'is-froze';


    hamburgerBtn.click(function(){
      $(this).toggleClass(active);
      navPanel.toggleClass(active);
      bars.toggleClass('animate');
      $('body').toggleClass(froze);
    });
  }
  mobileNav();



  function itemActive() {
    var browserPathname = window.location.pathname;
    var items = $('header nav li a');
    var active = 'is-active';

    items.each(function(){
      var itemURL = $(this).attr('href');

      if (browserPathname === itemURL) {
        items.removeClass(active);
        $(this).addClass(active);
      }
    });
  }
  itemActive();



}(jQuery));



// WEBPACK FOOTER //
// ./assets/js/nav.js